import React from "react";
import { colors } from "../../../../../../themes/Colors";

const AgencyHeader = () => {
  return (
    <div
      style={{
        width: "100%",
        height: 50,
        backgroundColor: colors.greenLight,
        display: "flex",
        alignItems: "center",
        fontWeight: "bold",
        fontSize: 12,
        color: colors.white,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          flex: 0.25,
        }}
      >
        <div style={{ marginLeft: 20 }}> COMPANY NAME</div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          flex: 0.15,
        }}
      >
        CONTACT NUMBER
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          flex: 0.15,
        }}
      >
        EMAIL
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          flex: 0.1,
        }}
      >
        CREATED ON
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          flex: 0.2,
        }}
      >
        SERVICES
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flex: 0.15,
        }}
      >
        ACTIONS
      </div>
    </div>
  );
};

export default AgencyHeader;
